// Placement options for the tooltip.
// Used for prop type checking.

export default ['auto', 'top', 'right', 'bottom', 'left'];
